import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InnerPagesService } from 'src/app/pages/common-layout/inner-pages.service';
import { responseMessageStatus, ResponseStatus } from '../../enum';
import { FormService } from 'src/@services/form.service';
import { RetailProgramInvestment } from 'src/models/retailProgramInvestment.model';
import { FormGroup } from '@angular/forms';
import { CommonPagesService } from '../../common-pages.service';
import { CommonService } from 'src/@services/common.service';
import { Investor } from 'src/models/investment.model';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-add-edit-premium',
    templateUrl: './add-edit-premium.component.html',
    styleUrls: ['./add-edit-premium.component.scss'],
    standalone: false
})
export class AddEditPremiumComponent {
  checked = false;
  loading = false;
  indeterminate = false;
  listOfData: any = [];
  listOfCurrentPageData: any[] = [];
  setOfCheckedId = new Set<number>();
  displayAddData: any;
  page: number = 0;
  progressBar: number = 0;
  reviewData: any[] = [];
  supplierId: string;
  formattedAddress: string = '';
  isSupplierRequest: boolean = true;
  sortField: string = 'BrandName'
  sortOrder: string = 'asc';
  companyDetails: {
    name: '';
    address1: '';
    address2: '';
    city: '';
    state: '';
    zip: '';
    country: '';
    qboSupplierId: '';
    retailPrograms: {
      _id: '';
      name: '';
      code: '';
      isActive: '';
      retailSupplierId: '';
    }[];
  };
  modalPageNumber: number;
  listOfReps: any[] = [];
  amountToPay: number;
  isLoading = false;
  programId: string | undefined;
  invoiceDescription: string =
    'Full year of Premium Content marketing services for the following brands: ';
  form: FormGroup;
  currentNextMonthYear: string = '';
  investmentLoading: boolean = false;
  loadingListData: boolean = true;
  operatorSiteId: string = null;
  @Input() isDataLoading: boolean = false;
  @Input() isAdmin: boolean = false;
  @Input() programDetail: any = '';
  @Input() currentSelectedData: any;
  @Output() closeModal = new EventEmitter<any>();

  userDetails = JSON.parse(localStorage.getItem('UserInfo'));

  showInvestorModal: boolean = false;

  supplierDetails = JSON.parse(sessionStorage.getItem('SupplierDetails'));

  // selectedBrandIds: Set<any> = new Set();
  expandSet: Set<any> = new Set();
  renewalEditRequest: boolean = false;
  netTerms: number = 30;
  currentInvestorData: Investor;
  estArrivalDate: Date = new Date();

  constructor(
    private _iS: InnerPagesService,
    private route: ActivatedRoute,
    public _fS: FormService,
    private _cpS: CommonPagesService,
    private _cS: CommonService,
    private _datepipe: DatePipe
  ) {
    this.supplierId = this.route.snapshot.paramMap.get('supplierId');
    _fS.retailProgramInvestmentForm_fb();
  }

  ngOnInit() {
    this.page = 0;
    this.programId = this.route.snapshot.queryParamMap.get('programId');

    if (this.programDetail.invoiceDescriptionText) {
      this.invoiceDescription = this.programDetail.invoiceDescriptionText + ' '
    }

    this.getUnpurchasedBrands();
  }

  sort(key: string, event: string) {
    if (key) {
      this.sortOrder = event == 'descend' ? 'desc' : 'asc';
      this.sortField = event ? key : 'RenewalDate';
      // this.cols.forEach((element) => {
      //   element.sortDir = null;
      // });
      // this.cols[index].sortDir = event;
      // this.page = 1;
      this.getUnpurchasedBrands();
    }
  }

  getUnpurchasedBrands() {
    this.loadingListData = true;
    this._iS
      .getStandardContent(
        this.programId,
        '',
        this.sortField,
        this.sortOrder,
        !this.currentSelectedData ? true : false,
        -1,
        100,
        [],
        [],
        this.supplierDetails.customerType
      )
      .subscribe((res: any) => {
        if (res.responseStatus === ResponseStatus.success) {
          if (!this.currentSelectedData) {
            this.listOfCurrentPageData = res.result?.records || [];

            if (this.listOfCurrentPageData.length > 0) {
              this.onExpandChange(this.listOfCurrentPageData[0].id, true);
            }
            this.loadingListData = false;
          } else {
            this.listOfCurrentPageData = [];

            this._fS.retailProgramInvestmentForm.patchValue({
              accountingNotes: this.currentSelectedData.brandInvestmentDetail.accountingNotes,
            });
            const editInvestmentRecords = res.result.records || [];
            editInvestmentRecords.forEach((content: any) => {
              if (
                content.brandInvestmentDetail?.retailProgramInvestmentId ===
                this.currentSelectedData.brandInvestmentDetail
                  ?.retailProgramInvestmentId
              ) {
                this.listOfCurrentPageData.push(content);
                this.onItemChecked(content.id, true);
              } else if (!content.brandInvestmentDetail) {
                this.onItemChecked(content.id, false);
                this.listOfCurrentPageData.push(content);
              }
            });
            if (this.listOfCurrentPageData.length > 0) {
              this.onExpandChange(this.listOfCurrentPageData[0].id, true);
            }
            this.loadingListData = false;
          }
        } else {
          this.loadingListData = false;
        }
      });
  }

  // Update the expand change method
  onExpandChange(brandId: any, expand: boolean): void {
    this.expandSet.clear();
    if (expand) {
      this.expandSet.add(brandId);
    } else {
      this.expandSet.delete(brandId);
    }
  }

  // Add brand row selection method
  onBrandRowClick(brandData: any): void {
    this.onItemChecked(brandData.id, !this.setOfCheckedId.has(brandData.id));
  }


  selectedBrandKeyList: string[] = [];

  onRowSelectionChange(selectedIds: string[]) {
    this.selectedBrandKeyList = selectedIds;
  }

  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }

  onItemChecked(id: number, checked: boolean): void {
    //expand this item
    this.onExpandChange(id, true);
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }

  onAllChecked(value: boolean): void {
    this.listOfCurrentPageData.forEach((item) =>
      this.updateCheckedSet(item.id, value)
    );
    this.refreshCheckedStatus();
  }

  onCurrentPageDataChange(listOfCurrentPageData: any): void {
    this.listOfCurrentPageData = listOfCurrentPageData;
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    this.checked = this.listOfCurrentPageData.every(({ id }) =>
      this.setOfCheckedId.has(id)
    );
    this.indeterminate =
      this.listOfCurrentPageData.some(({ id }) =>
        this.setOfCheckedId.has(id)
      ) && !this.checked;
  }

  handleOk(nextPageNumber: number) {
    if (nextPageNumber === 1) {
      this.reviewData = this.listOfCurrentPageData.filter((content: any) =>
        this.setOfCheckedId.has(content.id)
      );
      this.currentNextMonthYear = this.getCurrentMonthNextYear();
      if (this.reviewData?.length > 0) {
        this.page = nextPageNumber;
        this.progressBar = nextPageNumber;
      } else {
        this._cS.displayMessage('warning', 'Please select at least one brand');
      }
    } else if (nextPageNumber == 2) {
      this.isLoading = true;

      if (this.userDetails.localSupplier) {
        this.getLocalInvestorDetails();
      } else {
        this.getSupplierDetails();
      }
      this.amountToPay = 0;
      for (let index = 0; index < this.reviewData.length; index++) {
        this.amountToPay +=
          this.reviewData[index].brandAmount;
      }
      let invoiceDescriptionBase =
        'Full year of Premium Marketing services';

      if (this.programDetail.invoiceDescriptionText) {
        invoiceDescriptionBase = this.programDetail.invoiceDescriptionText + ' '
      }

      const brands = this.reviewData.map((e) => e.brandName);
      const count = brands.length;

      if (count === 1) {
        // Case 1: Only one brand
        this.invoiceDescription = `${invoiceDescriptionBase} for ${brands[0]}`;
      } else if (count === 2) {
        // Case 2: Two brands
        this.invoiceDescription = `${invoiceDescriptionBase} for ${brands[0]} and ${brands[1]} ($500/brand)`;
      } else if (count > 2) {
        // Case 3: Three or more brands
        const allButLast = brands.slice(0, -1).join(', ');
        const last = brands[brands.length - 1];
        this.invoiceDescription = `${invoiceDescriptionBase} for the following brands: ${allButLast}, and ${last} ($500/brand)`;
      }

      // this.invoiceDescription += ` (Renewal ${this.currentNextMonthYear})`;

      this._fS.retailProgramInvestmentForm
        .get('detailedDescription')
        ?.setValue(this.invoiceDescription);

      this.progressBar = nextPageNumber;

      this.page = nextPageNumber;
    }

    this.isLoading = false;
  }

  getLocalInvestorDetails() {
    this._iS.getInvestorDetails(this.supplierId, this.isSupplierRequest).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.companyDetails = {
          name: response.result.companyName || '',
          address1: response.result.streetAddress1 || '',
          address2: response.result.streetAddress2 || '',
          city: response.result.city || '',
          state: response.result.state || '',
          zip: response.result.zipCode || '',
          country: response.result.country || '',
          qboSupplierId: response.result.qboEntityId || '',
          retailPrograms: response.result.retailPrograms || {
            _id: '',
            name: '',
            code: '',
            isActive: '',
            retailSupplierId: '',
          },
        };
        this.currentInvestorData = response.result;
        this.formattedAddress = this.getFormattedAddress();
        response.result.retailPrograms.forEach((element) => {
          if (element.id === this.programId) {
            this.operatorSiteId = element.operatorSiteId || null;
          }
        });
        this.getSupplierReps();
      } else {
        this._cpS.isInvestmentHisoryLoading = false;
      }
    });
  }

  getSupplierDetails() {
    this._iS.getInvestor(this.supplierId).subscribe(
      (res: any) => {
        if (res.responseStatus == ResponseStatus.success) {
          if (res.result) {
            this.companyDetails = {
              name: res.result.investorDisplayName || '',
              address1: res.result.streetAddress1 || '',
              address2: res.result.streetAddress2 || '',
              city: res.result.city || '',
              state: res.result.state || '',
              zip: res.result.zipCode || '',
              country: res.result.country || '',
              qboSupplierId: res.result.qboEntityId || '',
              retailPrograms: res.result.retailPrograms || {
                _id: '',
                name: '',
                code: '',
                isActive: '',
                retailSupplierId: '',
              },
            };
            this.currentInvestorData = res.result;
            this.formattedAddress = this.getFormattedAddress();
            res.result.retailPrograms.forEach((element) => {
              if (element.id === this.programId) {
                this.operatorSiteId = element.operatorSiteId || null;
              }
            });
            this.getInvestorTerms();
            this.getSupplierReps();
          } else {
            this.getLocalInvestorDetails();
          }
        }
      },
      (error) => {
        console.error('API Error:', error);
      }
    );
  }

  getSupplierReps() {
    this._cpS
      .getSupplierInvestors(this.companyDetails.qboSupplierId, this.programId)
      .subscribe((res: any) => {
        if (res.responseStatus === ResponseStatus.success) {
          this.listOfReps = res.result;
          if (this.currentSelectedData) {
            this._fS.retailProgramInvestmentForm.patchValue({
              rep: this.currentSelectedData.brandInvestmentDetail.rep.id,
              isAgreed: true,
            });
          }
        }
      });
  }
  getInvestorTerms() {
    if (this.currentInvestorData.terms) {
      if (this.currentInvestorData.terms.id) {
        this.netTerms = this.currentInvestorData.terms.name?.split('Net ')[1]
          ? parseInt(this.currentInvestorData.terms.name?.split('Net ')[1])
          : 30;
      }
    }
  }
  newCreatedInvestor(event: {
    isVisibleInvestorDrawer: boolean;
    data: Investor;
  }) {
    this.showInvestorModal = event.isVisibleInvestorDrawer;
    if (event.data) {
      this.listOfReps?.splice(0, 0, event.data);
      this.listOfReps[0].id = event.data.id;
      this.showInvestorModal = false;
      this.listOfReps[0].name = event.data.investorDisplayName;
      this._fS.retailProgramInvestmentForm.patchValue({
        rep: this.listOfReps[0].id,
      });
    }
  }

  preventEnter(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }
  openNewRepModal() {
    this.showInvestorModal = true;
  }
  handleCancelInvestor() {
    this.showInvestorModal = false;
  }

  handleCancel(data?: any) {
    this.setOfCheckedId.clear();
    this.page = 0;
    this.progressBar = 0;
    this.listOfCurrentPageData = [];
    this.invoiceDescription =
      'Full year of Premium Content marketing services for the following brands: ';
    this.renewalEditRequest = false;
    this.currentSelectedData = null;
    this.closeModal.emit({ data: data });
  }

  handleGoBack() {
    this.page = this.page - 1;
    this.progressBar = this.page;
    this.invoiceDescription =
      'Full year of Premium Content marketing services for the following brands: ';
  }

  getCurrentMonthNextYear(): string {
    const today = new Date();
    const currentMonth = today.getMonth() + 1; // current month +1 
    const nextYear = today.getFullYear() + 1;

    const nextYearDate = new Date(nextYear, currentMonth, 1);

    return nextYearDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  calculateBrandTotalPrice(brandAmount: number, products: any[]) {
    return (
      brandAmount +
      products.filter((p) => p.amount).reduce((sum, p) => sum + p.amount, 0)
    );
  }

  getFormattedAddress() {
    if (
      !this.companyDetails.city &&
      !this.companyDetails.state &&
      !this.companyDetails.zip
    ) {
      return '';
    }
    return [
      this.companyDetails.city,
      this.companyDetails.state,
      this.companyDetails.zip,
    ].join(', ');
  }

  scheduleInvestment() {
    if (this._fS.retailProgramInvestmentForm.valid) {
      if (!this._fS.retailProgramInvestmentForm.get('isAgreed')?.value) {
        this._cS.displayMessage(
          'warning',
          'Please check terms and conditions to proceed'
        );
      } else {
        this.investmentLoading = true;

        if (this.currentInvestorData.isInvoice) {
          this.estArrivalDate.setDate(
            this.estArrivalDate.getDate() + this.netTerms
          );
        } else {
          this.estArrivalDate.setDate(
            this.estArrivalDate.getDate() + this.netTerms + 14
          );
        }

        const formvalue = this._fS.retailProgramInvestmentForm.value;

        let matchedRetailProgramSupplierId = '';
        const matchedProgram = this.companyDetails.retailPrograms.find(
          (element: any) => element.id === this.programId
        );
        const matchedRep = this.listOfReps.find(
          (element: any) => element.id === formvalue.rep
        );
        if (matchedProgram) {
          matchedRetailProgramSupplierId = matchedProgram.retailSupplierId;
        }
        const brandWithProductsForInvestment = this.reviewData.map(
          (brand: any) => {
            return {
              id: brand.id,
              name: brand.brandName,
              amount: brand.brandAmount,
              renewalDate: this._datepipe.transform(new Date(this.currentNextMonthYear), 'MM-dd-yyyy'),
              isActive: true
            };
          }
        );
        const investmentData: RetailProgramInvestment = {
          id: '',
          supplierId: this.supplierId,
          invester: {
            id: matchedRep.id,
            name: matchedRep.name,
          },
          program: {
            id: '',
            name: '',
          },
          amount: this.amountToPay,
          description: formvalue.detailedDescription,
          brands: brandWithProductsForInvestment,
          accountingNotes: formvalue.accountingNotes,
          retailProgramId: this.programId,
          retailSupplierId: matchedRetailProgramSupplierId,
          siteId: this.operatorSiteId,
          isRenewal: false,
          estimatedArrivalDate: this.estArrivalDate,
        };
        if (!this.currentSelectedData) {
          this.addInvestment(investmentData);
        } else {
          investmentData.id =
            this.currentSelectedData.brandInvestmentDetail.retailProgramInvestmentId;
          investmentData.isRenewal = this.currentSelectedData.brandInvestmentDetail.isRenewal;
          this.updateInvestment(investmentData);
        }
      }
    } else {
      this._cS.markFormGroupTouched(this._fS.retailProgramInvestmentForm);
    }
  }

  addInvestment(investmentData: RetailProgramInvestment) {
    this._cpS
      .addRetailProgramInvestment(investmentData)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.handleCancel(response.result);
          this._cpS.displayMessage(
            responseMessageStatus.success,
            response.message
          );
        } else {
          this._cpS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
        this.investmentLoading = false;
      });
  }
  updateInvestment(investmentData: RetailProgramInvestment) {
    this._cpS
      .updateRetailProgramInvestment(investmentData)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.handleCancel(response.result);
          this._cpS.displayMessage(
            responseMessageStatus.success,
            response.message
          );
        } else {
          this._cpS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
        this.investmentLoading = false;
      });
  }
}
